import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
import './ContactPage.css';
import { useLeadCapture } from '../hooks/useLeadCapture';

function ContactPage() {
    const { captureLead, isLoading } = useLeadCapture();
    const [localSuccess, setLocalSuccess] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: 'General Inquiry',
        message: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Capture lead in backend DB (non-blocking)
        captureLead({
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            source: 'Contact Page',
            message: `Subject: ${formData.subject}\n\n${formData.message}`,
            additionalData: { subject: formData.subject }
        }).catch(err => console.error("Database lead capture error:", err));

        // Show local success notification immediately
        setLocalSuccess(true);

        // Reset form
        setFormData({
            name: '',
            email: '',
            phone: '',
            subject: 'General Inquiry',
            message: '',
        });

        // Hide success message after 5 seconds
        setTimeout(() => {
            setLocalSuccess(false);
        }, 5000);
    };

    return (
        <>
            {/* Top Toast Notification */}
            {localSuccess && (
                <div className="contact-toast-top">
                    <span className="toast-icon">✓</span>
                    <p>Thank you! Your message has been sent to care@mlbsecurities.com. We'll get back to you soon.</p>
                </div>
            )}
            <div className="page contact-page-modern">
                {/* Hero Section */}
                <section className="contact-hero-modern">
                    <div className="contact-hero-content">
                        <span className="contact-badge">📧 Get In Touch</span>
                        <h1>
                            We'd Love to <span className="gradient-text">Hear From You</span>
                        </h1>
                        <p className="contact-hero-description">
                            Have questions about our loan products? Need assistance with your application?
                            Our team is here to help you every step of the way.
                        </p>
                    </div>
                </section>

                {/* Main Content */}
                <section className="contact-main-section">
                    <div className="contact-container">
                        {/* Contact Information */}
                        <div className="contact-info-side">
                            <div className="contact-info-card">
                                <h2>Contact Information</h2>
                                <p className="info-subtitle">Reach out to us through any of these channels</p>

                                <div className="contact-methods">
                                    <div className="contact-method">
                                        <div className="method-icon-contact">📞</div>
                                        <div className="method-details">
                                            <strong>Phone</strong>
                                            <a href="tel:+919997842548">+91-9997842548</a>
                                            <span className="method-note">Mon-Sat, 9:00 AM - 6:00 PM</span>
                                        </div>
                                    </div>

                                    <div className="contact-method">
                                        <div className="method-icon-contact">✉️</div>
                                        <div className="method-details">
                                            <strong>Email</strong>
                                            <a href="mailto:care@mlbsecurities.com">care@mlbsecurities.com</a>
                                            <span className="method-note">We'll respond within 24 hours</span>
                                        </div>
                                    </div>

                                    <div className="contact-method">
                                        <div className="method-icon-contact">💬</div>
                                        <div className="method-details">
                                            <strong>WhatsApp</strong>
                                            <a href="https://wa.me/919997842548" target="_blank" rel="noopener noreferrer">
                                                Chat with us
                                            </a>
                                            <span className="method-note">Instant messaging support</span>
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="social-connect">
                                <h3>Connect With Us</h3>
                                <div className="social-links-contact">
                                    <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                        <img src="https://img.icons8.com/color/48/facebook.png" alt="Facebook" />
                                    </a>
                                    <a href="https://www.linkedin.com/feed/update/urn:li:activity:7472556990527889409" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                        <img src="https://img.icons8.com/color/48/linkedin.png" alt="LinkedIn" />
                                    </a>
                                    <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                                        <img src="https://img.icons8.com/color/48/twitter--v1.png" alt="Twitter" />
                                    </a>
                                    <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                        <img src="https://img.icons8.com/color/48/instagram-new.png" alt="Instagram" />
                                    </a>
                                </div>
                            </div> */}
                            </div>
                        </div>

                        {/* Contact Form */}
                        <div className="contact-form-side">
                            <div className="contact-form-card-main">
                                <h2>Send Us a Message</h2>
                                <p className="form-subtitle">Fill out the form below and we'll get back to you soon</p>

                                <form className="contact-form-main" onSubmit={handleSubmit}>
                                    <div className="form-group-contact">
                                        <label htmlFor="name">Your Name <span className="required">*</span></label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            placeholder="Enter your full name"
                                            required
                                        />
                                    </div>

                                    <div className="form-group-contact">
                                        <label htmlFor="email">Email Address <span className="required">*</span></label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder="your.email@example.com"
                                            required
                                        />
                                    </div>

                                    <div className="form-group-contact">
                                        <label htmlFor="phone">Phone Number <span className="required">*</span></label>
                                        <input
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            placeholder="+91 XXXXX XXXXX"
                                            required
                                        />
                                    </div>

                                    <div className="form-group-contact">
                                        <label htmlFor="subject">Subject <span className="required">*</span></label>
                                        <select
                                            id="subject"
                                            name="subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="General Inquiry">General Inquiry</option>
                                            <option value="Loan Application">Loan Application</option>
                                            <option value="Existing Loan">Existing Loan Support</option>
                                            <option value="Documentation">Documentation Query</option>
                                            <option value="Payment Issue">Payment Issue</option>
                                            <option value="Feedback">Feedback</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>

                                    <div className="form-group-contact full-width">
                                        <label htmlFor="message">Your Message <span className="required">*</span></label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            placeholder="Tell us how we can help you..."
                                            rows="5"
                                            required
                                        />
                                    </div>

                                    <button type="submit" className="contact-submit-btn" disabled={isLoading}>
                                        {isLoading ? 'Sending...' : 'Send Message →'}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Map Section */}
                <section className="contact-map-section">
                    <h3>Visit Our Office</h3>
                    <div className="map-container">
                        <iframe
                            title="E-Fin Office Location"
                            src="https://www.google.com/maps?q=Second%20Floor,%20Plot%2015/2,%20Main%20Najafgarh%20Road,%20Rama%20Road,%20N.I.Area,%20West%20Delhi,%20New%20Delhi,%20Delhi,%20India,%20110015&output=embed"
                            loading="lazy"
                            allowFullScreen
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                </section>
            </div>
        </>
    );
}

export default ContactPage;
